export default __webpack_public_path__ + "static/media/search.005564e5.svg";